import { match } from 'ts-pattern'

import { CLASSIFICATION_TYPE_LABELS, SUPPORTED_CLASSIFICATION_TYPES } from '@documents/constants'
import { ClassificationResult, DocumentTypeOption } from '@documents/types'
import { UploadAndClassifyFileResponse } from '@frame/lib/api/tasks/types'

export function getMessage({ classificationResults }: { classificationResults?: ClassificationResult[] }) {
  if (!classificationResults) return 'Unable to classify document'

  // Filter out UNKNOWN from the message
  const filteredClassificationTypes = SUPPORTED_CLASSIFICATION_TYPES.filter((t) => t !== ClassificationResult.UNKNOWN)

  if (filteredClassificationTypes.length <= 2) {
    return `Only ${filteredClassificationTypes
      .map((type) => `${CLASSIFICATION_TYPE_LABELS[type]}s`)
      .join(' and ')} are accepted.`
  } else if (filteredClassificationTypes.length > 2) {
    const lastType = filteredClassificationTypes[filteredClassificationTypes.length - 1]
    return `Only ${filteredClassificationTypes
      .slice(0, filteredClassificationTypes.length - 1)
      .map((type) => `${CLASSIFICATION_TYPE_LABELS[type]}s`)
      .join(', ')} and ${CLASSIFICATION_TYPE_LABELS[lastType]} are accepted.`
  } else {
    throw new Error('No supported classification types available')
  }
}

export function getSupportedType({
  classificationResults,
  selectedType,
}: {
  classificationResults?: ClassificationResult[]
  selectedType?: ClassificationResult
}) {
  if (!classificationResults) return selectedType

  if (selectedType) return selectedType

  if (classificationResults && classificationResults.some((cr) => SUPPORTED_CLASSIFICATION_TYPES.includes(cr)))
    return classificationResults

  return undefined
}

export function getFileName(file?: File) {
  return file?.name || 'Unknown file name'
}

export function getFirstClassificationResult(data?: UploadAndClassifyFileResponse) {
  return data?.classifications?.[0]?.form_type
}

export function getConsumerIdentifiedDocumentType(
  documentType: DocumentTypeOption | null,
  skipAutoClassification: boolean
) {
  if (!skipAutoClassification) return null

  return match(documentType)
    .with(DocumentTypeOption.OFFER_LETTER, () => ClassificationResult.OFFER_LETTER)
    .otherwise(() => null)
}
